import store from '@/store';
import { leaseType } from '@/util/dictList.js';
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 6,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  searchIndex: 7,
  rowKey: 'index',
  searchLabelWidth: 100,
  column: [
    {
      label: '主键id',
      prop: 'id',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      width: 120,
      search: true,
      searchOrder: 992,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      width: 100,
      type: 'input',
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      dicData: store.getters.porductTypes,
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'select',
      search: true,
      searchMultiple: true,
      hide: true,
      showColumn: false,
      searchOrder: 999,
      dicData: store.getters.porductTypes,
    },
    {
      label: '租率',
      prop: 'rate',
      type: 'select',
      dicData: [],
      props: {
        label: 'lable',
        value: 'rate',
      },
    },
    {
      label: '租期',
      prop: 'tenancy',
      type: 'select',
      formatter: (val, value) => {
        return value ? value + '期' : '-';
      },
      dicData: leaseType,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 998,
    },
    {
      label: '手机号',
      prop: 'phoneNumber',
      type: 'input',
      width: 100,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
      search: true,
      searchOrder: 997,
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'input',
    },
    {
      label: '客户期数',
      prop: 'currentTenancy',
      type: 'input',
      formatter: (val, value) => {
        return value ? `第${value}期/共${val['tenancy']}期` : '-';
      },
    },
    {
      label: '代理商期数',
      width: '100',
      prop: 'agentCurrentTenancy',
      type: 'input',
      formatter: (val, value) => {
        return value ? `第${value}期/共${val['tenancy']}期` : '-';
      },
    },
    {
      label: '本期应还租金',
      prop: 'lendingAmountPer',
      width: 110,
      type: 'input',
      // formatter: (val, value, label) => {
      //     return value + "元";
      // },
    },
    // {
    //   label: '本期实付租金',
    //   prop: 'actualPayment',
    //   width: 110,
    //   type: 'input',
    // formatter: (val, value, label) => {
    //     return value + "元";
    // },
    // },
    // {
    //   label: '当前所处状态',
    //   prop: 'corporateStep',
    //   type: 'select',
    //   search: true,
    //   hide: true,
    //   searchOrder: 990,
    //   dicData: [
    //     {
    //       label: '客户还租',
    //       value: 1,
    //     },
    //     {
    //       label: '违约结清',
    //       value: 2,
    //     },
    //   ],
    // },
    // {
    //   label: '当前所处状态',
    //   prop: 'corporateStepName',
    //   type: 'select',
    //   width: 100,
    //   dicData: [
    //     {
    //       label: '客户还租',
    //       value: 1,
    //     },
    //     {
    //       label: '违约结清',
    //       value: 2,
    //     },
    //   ],
    // },
    {
      label: '当前流程状态',
      prop: 'followStatusName',
      type: 'select',
      width: 100,
    },
    {
      label: '当前状态',
      prop: 'repaymentType',
      type: 'select',
      search: true,
      hide: true,
      searchOrder: 994,
      dicData: [
        {
          label: '待还款',
          value: 1,
        },
        // {
        //   label: '入账中',
        //   value: 2,
        // },
        // {
        //   label: '已入账',
        //   value: 3,
        // },
        {
          label: '驳回',
          value: 4,
        },
      ],
    },
    {
      label: '催收人',
      prop: 'collectorUserName',
      type: 'input',
      formatter: (val, value) => {
        return value || '没有催收过';
      },
    },
    {
      label: '催收次数',
      prop: 'collectorCount',
      type: 'input',
      formatter: (val, value) => {
        return value || '没有催收过';
      },
    },
    {
      label: '最近催收时间',
      prop: 'collectorCreateTime',
      type: 'date',
      width: 100,
            formatter: (val, value) => {
        return value || '没有催收过';
      },
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      search: true,
      searchOrder: 1000,
      hide: true,
      searchMultiple: true,
      filterable:true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
    },
    // {
    //   label: '所在部门',
    //   prop: 'corporateStep',
    //   // searchMultiple: true,
    //   type: 'select',
    //   searchOrder: 993,
    //   hide: true,
    //   formatter: (val, value) => {
    //     let label = '';
    //     if (value) {
    //       if ([201,101].includes(value)) {
    //         label = '催收';
    //       } else if ([206,106].includes(value)) {
    //         label = '行动';
    //       } else if ([207,107].includes(value)) {
    //         label = '谈判';
    //       } else if ([104,204].includes(value)) {
    //         label = '车辆管理';
    //       } else {
    //         label = '财务';
    //       }
    //     }
    //     return label;
    //   },
    //   dicData: [
    //     {
    //       label: '催收',
    //       value: 201,
    //     },
    //     {
    //       label: '行动',
    //       value: 206,
    //     },
    //     {
    //       label: '谈判',
    //       value: 207,
    //     },
    //   ],
    // },
    {
      label: '还租日期',
      prop: 'currentLendingDateSearch',
      type: 'date',
      minWidth: 100,
      search: true,
      hide: true,
      searchRange: true,
      searchOrder: 996,
      searchType: 'daterange',
      valueFormat: 'yyyy-MM-dd',
      sortable: 'custom',
      order: '',
    },
    {
      label: '还租日查询',
      prop: 'dateInteger',
      type: 'select',
      search: true,
      searchMultiple: true,
      hide: true,
      showColumn: false,
      searchOrder: 995,
      dicData: (() => {
        let arr = [];
        for (let i = 1; i < 32; i++) {
          arr.push({
            label: i + '日',
            value: i,
          });
        }
        return arr;
      })(),
    },
  ],
};

//月代偿预计
export const monthCompensationOption = [
  {
    label: '每期租金',
    prop: 'lendingAmountPer',
    type: 'input',
    formatter: (val, value) => {
      return value + '元';
    },
  },
  {
    label: '还租日期',
    prop: 'currentLendingDate',
    type: 'date',
    width: 100,
    searchType: 'daterange',
    valueFormat: 'yyyy-MM-dd',
  },
  {
    label: '应还代管滞纳金',
    prop: 'totalNeedRepaymentOverdueFine',
    width: 110,
    type: 'input',
  },
  {
    label: '实付代管滞纳金',
    prop: 'agentActualPaymentOverdueFine',
    width: 110,
    type: 'input',
    formatter: (val, value) => {
      return value ||0;
    },
  },
];

//7日代偿预计
export const sevenCompensationOption = [
  {
    label: '每期租金',
    prop: 'lendingAmountPer',
    type: 'input',
    formatter: (val, value) => {
      return value + '元';
    },
  },
  {
    label: '还租日期',
    prop: 'currentLendingDate',
    type: 'date',
    searchType: 'daterange',
    valueFormat: 'yyyy-MM-dd',
  },
  {
    label: '应还代管滞纳金',
    prop: 'totalNeedRepaymentOverdueFine',
    width: 120,
    type: 'input',
  },
  {
    label: '实付代管滞纳金',
    prop: 'agentActualPaymentOverdueFine',
    width: 120,
    type: 'input',
    formatter: (val, value) => {
      return value ||0;
    },
  },
];

//逾期未代偿
export const notCompensationOption = [
  // {
  //   label: '代理商本期应还租期数',
  //   prop: 'periods',
  //   type: 'input',
  // },
  {
    label: '代理商本期应还租日期',
    prop: 'currentLendingDate',
    type: 'date',
    searchType: 'daterange',
    valueFormat: 'yyyy-MM-dd',
  },
  {
    label: '代理商本期逾期天数',
    prop: 'delayDays',
    type: 'input',
  },
  // {
  //   label: '应还代管滞纳金',
  //   prop: 'totalNeedRepaymentOverdueFine',
  //   width: 110,
  //   type: 'input',
  // },
  {
    label: '实付代管滞纳金',
    prop: 'agentActualPaymentOverdueFine',
    width: 110,
    type: 'input',
    formatter: (val, value) => {
      return value ||0;
    },
  },
  {
    label: '逾期期数',
    prop: 'overdueNumber',
    type: 'input',
    formatter: (val, value) => {
      return value ? value + '期' : '0期';
    },
  },
  {
    label: '已代偿期数',
    prop: 'agentCount',
    type: 'input',
    formatter: (val, value) => {
      return value ? value + '期' : '0期';
    },
  },
  // {
  //   label: '剩余未还总租金',
  //   prop: 'remainingPeriod',
  //   width: 110,
  //   type: 'input',
  // },
  // {
  //   label: '剩余未还总滞纳金',
  //   prop: 'remainingPeriodOverdueFine',
  //   width: 110,
  //   type: 'input',
  // },
  // {
  //   label: '当前移交部门',
  //   prop: 'sectionString',
  //   type: 'select',
  //   hide: false,
  //   dicData: [
  //     {
  //       label: '催收',
  //       value: 0,
  //     },
  //     {
  //       label: '行动',
  //       value: 1,
  //     },
  //     {
  //       label: '谈判',
  //       value: 2,
  //     },
  //     {
  //       label: '法务',
  //       value: 2,
  //     },
  //   ],
  // },
  // {
  //   label: '拖车状态',
  //   prop: 'tuoCarStatusName',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '谈判状态',
  //   prop: 'negotiationStatusName',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '诉讼状态',
  //   prop: 'litigationStatusName',
  //   type: 'input',
  //   width: 90,
  // },
];

//已代偿
export const compensationOption = [
  // {
  //   label: '应还代管滞纳金',
  //   prop: 'totalNeedRepaymentOverdueFine',
  //   width: 110,
  //   type: 'input',
  // },
  {
    label: '实付代管滞纳金',
    prop: 'agentActualPaymentOverdueFine',
    width: 110,
    type: 'input',
    formatter: (val, value) => {
      return value ||0;
    },
  },
  {
    label: '已代偿期数',
    prop: 'agentCount',
    type: 'input',
    formatter: (val, value) => {
      return value ? value + '期' : '0期';
    },
  },
  {
    label: '剩余未还代管租金',
    prop: 'remainingPeriod',
    width: 110,
    type: 'input',
  },
  {
    label: '剩余未还代管滞纳金',
    prop: 'remainingPeriodOverdueFine',
    width: 110,
    type: 'input',
  },
  // {
  //   label: '当前移交部门',
  //   prop: 'sectionString',
  //   type: 'select',
  //   dicData: [
  //     {
  //       label: '催收',
  //       value: 0,
  //     },
  //     {
  //       label: '行动',
  //       value: 1,
  //     },
  //     {
  //       label: '谈判',
  //       value: 2,
  //     },
  //     {
  //       label: '法务',
  //       value: 2,
  //     },
  //   ],
  // },
  {
    label: '当前流程状态',
    prop: 'followStatusName',
    type: 'select',
    width: 100,
    hide: true,
  },
  // {
  //   label: '拖车状态',
  //   prop: 'tuoCarStatusName',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '谈判状态',
  //   prop: 'negotiationStatusName',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '诉讼状态',
  //   prop: 'litigationStatusName',
  //   type: 'input',
  //   width: 90,
  // },
];
